function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import PropTypes from "prop-types";
import React from "react";
import cc from "classcat";
import { ExclamationTriangleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Slot } from "@radix-ui/react-slot";
import { twMerge } from "tailwind-merge";
import { CheckCircleIcon, ExclamationCircleIcon, ClockIcon } from "@heroicons/react/24/solid";
import Tooltip from "./Tooltip/Tooltip";
export var supportedVariants = [
    "primary",
    "danger",
    "success",
    "warning",
    "pending"
];
Alert.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(supportedVariants).isRequired,
    title: PropTypes.node,
    onDismiss: PropTypes.func,
    childrenContainerClassName: PropTypes.string,
    icon: PropTypes.node,
    iconTooltip: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    iconLeftClassName: PropTypes.string
};
export default function Alert(_param) {
    var children = _param.children, variant = _param.variant, className = _param.className, title = _param.title, onDismiss = _param.onDismiss, childrenContainerClassName = _param.childrenContainerClassName, icon = _param.icon, iconTooltip = _param.iconTooltip, iconLeftClassName = _param.iconLeftClassName, props = _object_without_properties(_param, [
        "children",
        "variant",
        "className",
        "title",
        "onDismiss",
        "childrenContainerClassName",
        "icon",
        "iconTooltip",
        "iconLeftClassName"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        className: twMerge(cc([
            "relative rounded-md border-2 px-3 py-4 text-base",
            {
                "border-blue-500  bg-blue-50 text-blue-700 dark:bg-blue-500 dark:text-gray-200": variant === "primary" || variant === "pending"
            },
            {
                "border-green-500  bg-green-50 text-green-700 dark:bg-green-500 dark:text-gray-200": variant === "success"
            },
            {
                "border-red-500  bg-red-50 text-red-600 dark:bg-red-500 dark:text-gray-200": variant === "danger"
            },
            {
                "border-orange-500  bg-orange-50 text-orange-600 dark:bg-orange-500 dark:text-gray-200": variant === "warning"
            },
            {
                "py-2": title
            },
            className
        ])),
        role: "alert"
    }, props), /*#__PURE__*/ React.createElement("div", {
        className: cc([
            {
                "flex items-center": !title
            },
            "gap-x-2 pr-5"
        ])
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "flex items-center gap-x-2 self-start",
            iconLeftClassName
        ]))
    }, iconTooltip ? /*#__PURE__*/ React.createElement(Tooltip, {
        content: iconTooltip
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(LeftIcon, {
        variant: variant
    }))) : /*#__PURE__*/ React.createElement(LeftIcon, {
        variant: variant
    }), title && /*#__PURE__*/ React.createElement("div", {
        className: "mb-1 flex items-center text-lg justify-between font-bold"
    }, title), onDismiss && /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: onDismiss,
        className: "absolute right-0 top-0 inline-flex rounded-md p-1 text-gray-400 focus:outline-none focus:ring-2"
    }, /*#__PURE__*/ React.createElement(XMarkIcon, {
        className: "h-7 w-7"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "flex-grow"
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "flex flex-1 items-center",
            childrenContainerClassName
        ]))
    }, children))));
}
LeftIcon.propTypes = {
    variant: PropTypes.oneOf(supportedVariants).isRequired
};
function LeftIcon(param) {
    var variant = param.variant;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, variant === "primary" && /*#__PURE__*/ React.createElement(Slot, {
        className: cc([
            "h-10 w-10 flex-shrink-0 fill-blue-500 dark:fill-gray-200"
        ])
    }, variant === "primary" && /*#__PURE__*/ React.createElement(ExclamationCircleIcon, {
        className: "h-8 w-8"
    })), variant === "pending" && /*#__PURE__*/ React.createElement(Slot, {
        className: cc([
            "h-10 w-10 flex-shrink-0 fill-blue-500 dark:fill-gray-200"
        ])
    }, variant === "pending" && /*#__PURE__*/ React.createElement(ClockIcon, {
        className: "h-8 w-8"
    })), variant === "danger" && /*#__PURE__*/ React.createElement(Slot, {
        className: cc([
            "h-10 w-10 flex-shrink-0 fill-red-500 dark:fill-gray-200"
        ])
    }, variant === "danger" && /*#__PURE__*/ React.createElement(ExclamationTriangleIcon, {
        className: "h-8 w-8"
    })), variant === "success" && /*#__PURE__*/ React.createElement(Slot, {
        className: cc([
            "h-10 w-10 flex-shrink-0 fill-green-500 dark:fill-gray-200"
        ])
    }, variant === "success" && /*#__PURE__*/ React.createElement(CheckCircleIcon, {
        className: "h-8 w-8"
    })), variant === "warning" && /*#__PURE__*/ React.createElement(Slot, {
        className: cc([
            "h-10 w-10 flex-shrink-0 fill-orange-500 dark:fill-gray-200"
        ])
    }, variant === "warning" && /*#__PURE__*/ React.createElement(ExclamationCircleIcon, {
        className: "h-8 w-8"
    })));
}
